"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Queries for all predicates of a path subject
 */

var PredicatesHandler =
/*#__PURE__*/
function () {
  function PredicatesHandler() {
    _classCallCheck(this, PredicatesHandler);
  }

  _createClass(PredicatesHandler, [{
    key: "handle",
    value: function handle(pathData) {
      return pathData.extendPath({
        distinct: true,
        select: '?predicate',
        finalClause: function finalClause(queryVar) {
          return "".concat(queryVar, " ?predicate ?object.");
        },
        property: pathData.property
      });
    }
  }]);

  return PredicatesHandler;
}();

exports.default = PredicatesHandler;